'use strict';

import { Entity } from './Entity';

export enum APP_REFERENCE {
  CURRENTCLIENT = 'dialpad',
  INTULSE_EXTERNAL = 'intulse_external',
  SIMPLII = 'simplii',
}

export class App extends Entity {
  protected id: number;
  protected name;
  protected reference;
  protected features;

  constructor() {
    super();
  }

  public hydrate(data: any) {
    this.id = data.id;
    this.name = data.name;
    this.reference = data.reference;
    this.features = data.features;
  }

  public getId() {
    return this.id;
  }

  public getName() {
    return this.name;
  }

  public getReference() {
    return this.reference;
  }

  public getFeatures() {
    return this.features;
  }
}
